import { jsx } from "@emotion/react/jsx-runtime";
import { useContext } from "react";
import backgroundColorContext from "./backgroundColorContext.mjs";
import getVisualColor from "./getVisualColor.mjs";
function BackgroundColorContextProvider(_ref) {
  let {
    backgroundColor,
    children
  } = _ref;
  let parentBackgroundColor = useContext(backgroundColorContext);
  let visualColor = getVisualColor(parentBackgroundColor, backgroundColor);
  return /* @__PURE__ */jsx(backgroundColorContext.Provider, {
    value: visualColor,
    children
  });
}
export { BackgroundColorContextProvider as default };